import { sanitizeEmailHtml } from 'utils/sanitizeEmailHtml';

export const formatPreviewDescription = (description: string, locale: string, plainText = false) => {
  const document = new DOMParser().parseFromString(plainText ? '' : sanitizeEmailHtml(description), 'text/html');
  if (plainText) document.body.textContent = description;

  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
  const nodes: Text[] = [];
  while (walker.nextNode()) nodes.push(walker.currentNode as Text);

  // Segment the whole description so sentence boundaries also work across inline markup.
  const text = nodes.map((node) => node.data).join('');
  const sentences = Array.from(new Intl.Segmenter(locale, { granularity: 'sentence' }).segment(text));
  const breaks = sentences.slice(0, -1).flatMap(({ segment, index }) => {
    const end = index + segment.length;
    const start = index + segment.trimEnd().length;
    return /[\r\n]/.test(text.slice(start, end)) ? [] : [{ start, end }];
  });

  let offset = 0;
  for (const node of nodes) {
    const end = offset + node.length;
    let cursor = 0;
    let formatted = '';

    for (const boundary of breaks) {
      if (boundary.start > end || boundary.end < offset) continue;

      const startInNode = Math.max(0, boundary.start - offset);
      const endInNode = Math.min(node.length, boundary.end - offset);
      formatted += node.data.slice(cursor, startInNode);
      if (boundary.start > offset && boundary.start <= end) formatted += '\n';
      cursor = endInNode;
    }

    node.data = formatted + node.data.slice(cursor);
    offset = end;
  }

  return document.body.innerHTML;
};
